import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import LatestBookValueHoldingsReportCriteria from './LatestBookValueHoldingsReportCriteria';
import { Neo } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../App/Services/AppService';
import { TextConstants } from '../../../Common/TextConstants';

@NeoReport("LatestBookValueHoldings",  { category: MaintenanceReportCategories.SystemInformationReports})
export default class LatestBookValueHoldingsReport extends Report<LatestBookValueHoldingsReportCriteria>{
    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient)
    ) {
        super(LatestBookValueHoldingsReportCriteria);
    }

    public renderCriteria() {
        return (
        <>
        <Neo.GridLayout xxl={3}>
                <Neo.FormGroup bindContext={this.criteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                    <Neo.AutoCompleteDropDown
                        itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                        bind={this.criteria.meta.StaticServiceProviderFileGroupingID}
                        bindDisplay={this.criteria.meta.serviceProviderGroupingName}
                        displayMember={"serviceProviderGroupingName"}
                        items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                        .sort((x,y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                        />
                </Neo.FormGroup>
                <Neo.FormGroup
                        appendText="fa-calendar"
                        label={TextConstants.Labels.ReportDate}
                        bind={this.criteria.meta.reportDate}
                />
            </Neo.GridLayout>
        </>);
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}